export function replaceCustomerSuccess(str?: string): string {
    if (typeof str === 'string') {
        return str.replace(/Customer Success/g, 'CS');
    }
    return '';
}
